//import { reducers as lxpReducers } from "@sf-lxp";
import { SFCoreReducers as coreReducers } from "@sf-core";
import { reducers as launchPadLayoutActions } from "@sf-launchpad";

export const reducers = {
  //...lxpReducers,
  ...coreReducers,
  ...launchPadLayoutActions,
};
